import { render, staticRenderFns } from "./goodLicenceHistory.vue?vue&type=template&id=8ffabf94&scoped=true"
import script from "./goodLicenceHistory.vue?vue&type=script&lang=js"
export * from "./goodLicenceHistory.vue?vue&type=script&lang=js"
import style0 from "./goodLicenceHistory.vue?vue&type=style&index=0&id=8ffabf94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffabf94",
  null
  
)

export default component.exports